import { Grid, SxProps, Theme } from "@mui/material";

type ScreenContainerProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  removePadding?: boolean;
};

export function ScreenContainer({
  children,
  sx,
  removePadding,
}: ScreenContainerProps) {
  return (
    <Grid
      item
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "start",
        width: "100%",
        ...sx,
      }}
      paddingLeft={{
        xs: removePadding ? "0px" : "15px",
        sm: removePadding ? "0px" : "40px",
      }}
      paddingRight={{
        xs: removePadding ? "0px" : "15px",
        sm: removePadding ? "0px" : "40px",
      }}
      xs={12}
    >
      {children}
    </Grid>
  );
}
